<template>
  <div class="emailsWrapper">
    <br>
    <p style="padding-top:10px">add email</p>
    <div class="inputWrapper">

      <div class="form-group text-box">
          <input type="text" class="form-control email" :class="{danger: hasError}" v-model="email" v-on:blur="validate">
      </div>
      <div class="btn-add"><button class="add-email" @click="addEmail">enter</button></div>
    </div>

    <div class="listWrapper">
      <a :class="{default: showList}" @click="showList = !showList">
        <template v-if="showList">-</template>
        <template v-else>+</template>
        current emails
      </a>
      <ul v-if="showList">
        <li v-if="emails.length ===0">no emails</li>
        <li v-for="(email, index) in emails">{{email}} <a class="remove" @click="remove(emails.indexOf(email))">remove</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import EmailValidator from 'email-validator'
export default {
  props: {
    emails:[Array]
  },
  data(){
    return {
      email: "",
      showList: false,
      hasError: false
    }
  },
  methods: {
    remove(key){
      this.$emit('removeEmail', key)
    },

    validate(){
      if(this.email == ""){
        this.$emit('removeError', ['email_error', 'email_exists'])
        this.hasError=false
      }else{
        if(EmailValidator.validate(this.email)){
          this.$emit('removeError', ['email_error', 'email_exists'])
          this.hasError=false
        }else{
          this.$emit('pushError', 'email_error')
          this.$emit('removeError', ['email_exists'])
          this.hasError=true
        }
      }
    },

    addEmail() {
      if (this.email && !this.emails.includes(this.email) && !this.hasError) {
        this.$emit('pushEmail', this.email)
        this.$emit('removeError', ['email_exists'])
        this.hasError=false
        this.email=""
      }else if(this.emails.includes(this.email)){
        this.$emit('pushError', 'email_exists')
        this.hasError=true
      }else if(this.email===""){
        this.$emit('pushError', 'email_error')
        this.hasError=true
      }
    }
  }
}
</script>


